import { BaseCheckoutCardConfig } from '../checkout-card/base-checkout-card-config.interface';
import { PaysafeEnvironment } from './paysafe-environment.enum';

export interface PaysafeConfig extends BaseCheckoutCardConfig {
  accountId: number;
  environment: PaysafeEnvironment;
  key: string;
}
